
import { toast } from 'react-hot-toast';
import { Plus, Mail } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';
import { useUserUpdateMutation } from '../../../redux/setting';
import { useEffect, useState } from 'react';
import { useGetUserQuery } from '../../../redux/auth';

 
export default function NotificationSettings() {
  const [form, setForm] = useState({
    reminder_to_post: false,
    new_msg_notification: false,
    receive_msg_from_ngl: false,
  });

  const [updateSettings, { isLoading }] = useUserUpdateMutation();
  const { data: userData, isLoading: isLoadingUser } = useGetUserQuery();

  // Load settings from user data when available
  useEffect(() => {
    if (userData?.data) {
      const userSettings = {
        reminder_to_post: Boolean(Number(userData.data.reminder_to_post || 0)) as boolean,
        new_msg_notification: Boolean(Number(userData.data.new_msg_notification || 0)) as boolean,
        receive_msg_from_ngl: Boolean(Number(userData.data.receive_msg_from_ngl || 0)) as boolean,
      };
      setForm(userSettings);
    }
  }, [userData]);

  const handleToggle = (key: keyof typeof form) => {
    const updated = { ...form, [key]: !form[key] };
    setForm(updated);
    // localStorage.setItem('notificationSettings', JSON.stringify(updated));
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        ...form,
        // reminder_to_post: form.reminder_to_post,
        // new_msg_notification: form.new_msg_notification,
        // receive_msg_from_ngl: form.receive_msg_from_ngl,
      }).unwrap();
      toast.success('Settings saved successfully!');
    } catch (error: any) {
      const message = error?.data?.message || 'Something went wrong.';
      toast.error(`Failed to save settings: ${message}`);
    }
  };

  return (
    <div className="flex justify-center overflow-hidden no-scrollbar pt-10 bg-[#f5f5f5] h-screen px-4 py-6 text-black">
      <div className="w-full max-w-sm">
        <CustomAppBar title="Notifications" />

        <div className="bg-white rounded-2xl p-4 mt-8 space-y-6 shadow-md">
          <SettingToggle
            title="Reminders to post"
            description="Share your link 😛 Tap here"
            icon={<Plus className="w-5 h-5 text-gray-800" />}
            checked={form.reminder_to_post}
            onChange={() => handleToggle('reminder_to_post')}
          />

          <SettingToggle
            title="New messages"
            description="You have a new message! Tap to open"
            icon={<Mail className="w-5 h-5 text-gray-800" />}
            checked={form.new_msg_notification}
            onChange={() => handleToggle('new_msg_notification')}
          />

          <SettingToggle
            title="Receive from NGL"
            description="Receive helpful messages from us"
            checked={form.receive_msg_from_ngl}
            onChange={() => handleToggle('receive_msg_from_ngl')}
          />

         
          <button
            onClick={handleSave}
            disabled={isLoading}
            className="w-full mt-4 bg-black text-white py-2 rounded-xl font-bold hover:bg-opacity-80 transition"
          >
            {isLoading ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </div>
    </div>
  );
}

function SettingToggle({ title, description, icon, checked, onChange }: any) {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-start space-x-4">
        <div className="bg-white rounded-full p-2 shadow-sm">{icon}</div>
        <div>
          <p className="font-bold text-gray-900">{title}</p>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
      <label className="inline-flex items-center cursor-pointer">
        <input type="checkbox" className="sr-only" checked={checked} onChange={onChange} />
        <div
          className={`w-11 h-6 ${checked ? 'bg-green-500' : 'bg-gray-300'
            } rounded-full relative transition duration-200`}
        >
          <div
            className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md border transition-transform duration-200 ${checked ? 'translate-x-5' : ''
              }`}
          ></div>
        </div>
      </label>
    </div>
  );
}
